import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const ChatMessageBubble = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M8.12 20H12M8.264 20H4.925c-.823 0-1.235-.995-.653-1.576l1.09-1.09M4 12a8 8 0 1 1 8 8M5.73 16.96l-.37.37M5.733 16.963A7.958 7.958 0 0 1 4 12" />
    </svg>
  );
};
